import * as _ from 'lodash';
import type { IScopeRolesData } from './server/model/IScopeRolesData';
import { PermissionMode, RoleMode } from './server/enums';

function formatPermission(dst: string[], permission: PermissionMode, name: string) {
    if (permission === PermissionMode.WriteLimited) {
        dst.push(`${name} (begränsad)`);
    } else if (permission === PermissionMode.ReadAll) {
        dst.push(`${name} (endast läsa)`);
    } else if (permission === PermissionMode.WriteAll) {
        dst.push(name);
    }
}

function parseRoles(roles: RoleData) {
    let result: string[] = [];

    if (roles.Mode === RoleMode.Full) {
        result.push('Administratör');
    } else if (roles.Mode === RoleMode.Detailed) {
        result.push("Grundläggande läsbehörighet");
        formatPermission(result, roles.PersonBasic, "Personer/Grund");
        formatPermission(result, roles.PersonContact, "Personer/Kontaktuppgifter");
        formatPermission(result, roles.PersonWage, "Personer/Arvode");
        formatPermission(result, roles.PersonDocument, "Personer/Dokument");
        formatPermission(result, roles.Equipment, "Utrustning");
        formatPermission(result, roles.Mission, "Uppdrag");
        formatPermission(result, roles.Meeting, "Möten & Närvaro");
        formatPermission(result, roles.Payment, "Arvoden");
        formatPermission(result, roles.Organization, "Organisationer");
        formatPermission(result, roles.Transaction, "Lönetransaktioner");
    }

    return result;
}

export class RoleData {
    Mode: RoleMode;
    PersonBasic: PermissionMode;
    PersonContact: PermissionMode;
    PersonWage: PermissionMode;
    PersonDocument: PermissionMode;
    Equipment: PermissionMode;

    Meeting: PermissionMode;
    Mission: PermissionMode;
    Payment: PermissionMode;
    Organization: PermissionMode;

    Transaction: PermissionMode;

    roles: string[];
    display: string;
    hasAccess: boolean;
    isAdmin: boolean;
    isLimitedMeeting: boolean;

    constructor(json?: IScopeRolesData) {
        if (json) {
            this.Mode = json.Mode;
            this.PersonBasic = json.PersonBasic;
            this.PersonContact = json.PersonContact;
            this.PersonWage = json.PersonWage;
            this.PersonDocument = json.PersonDocument;
            this.Equipment = json.Equipment;
            this.Meeting = json.Meeting;
            this.Mission = json.Mission;
            this.Payment = json.Payment;
            this.Organization = json.Organization;
            this.Transaction = json.Transaction;
        } else {
            this.Mode = RoleMode.None;
            this.PersonBasic = PermissionMode.None;
            this.PersonContact = PermissionMode.None;
            this.PersonWage = PermissionMode.None;
            this.PersonDocument = PermissionMode.None;
            this.Equipment = PermissionMode.None;
            this.Meeting = PermissionMode.None;
            this.Mission = PermissionMode.None;
            this.Payment = PermissionMode.None;
            this.Organization = PermissionMode.None;
            this.Transaction = PermissionMode.None;
        }

        this.roles = parseRoles(this);
        this.display = this.roles.join(', ');
        this.hasAccess = this.Mode === RoleMode.Full || this.Mode === RoleMode.Detailed;
        this.isAdmin = this.Mode === RoleMode.Full;
        this.isLimitedMeeting = this.Mode === RoleMode.Detailed && this.Meeting === PermissionMode.WriteLimited;
    }
}